































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import {
  SitePerms,
  PermGroup,
  SitePerm,
  siteAdminPermApis,
  adminType,
  InternalSite,
  InvalidParam,
  PermMembers
} from '../../api';
import EmployeeSelectM from '@/components/vantM/EmployeeSelectM.vue';
import RoleSelectM from '@/components/vantM/RoleSelectM.vue';

@Component({ components: { EmployeeSelectM, RoleSelectM } })
export default class SitePermsTable extends Vue {
  @Prop({ required: true }) tabValue!: any;

  loading = true;
  finished = false;
  dialogLoading = false;
  dialogFinished = false;
  perms: SitePerms = { groups: [] };
  selectPerm: SitePerm = { id: 0, status: 0, site_id: 0, name: '', title: '', rw_sep: false };
  data: any = [];
  siteId = 0;
  PermDialogShow = false;
  membersDialogShow = false;
  EmployeeDialogShow = false;
  RoleDialogShow = false;
  permType = 'employees';
  members: PermMembers | [] = [];
  errors = {};
  targetId: string | number = '';
  roleTargetId: string | number = '';

  watchParams() {
    return [this.$route, this.tabValue];
  }

  mounted() {
    this.$watch(this.watchParams, this.refreshPerms);
    this.refreshPerms();
  }

  async refreshPerms() {
    const routeSiteId = parseInt(this.$route.params.id);
    if (Number.isInteger(routeSiteId)) {
      this.siteId = routeSiteId;
    }
    this.loading = true;
    this.finished = false;
    this.perms = { groups: [] };
    this.data = [];
    try {
      this.perms = await siteAdminPermApis.getSitePerms(this.siteId);
      this.data = this.perms.groups.map(this._buildGroupData);
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  _buildGroupData(group: PermGroup): any {
    let children: any = [];
    if (group.perms) {
      children = group.perms.map(p => this._buildPermData(group, p));
    }
    return {
      id: `group-${group.id}`,
      group,
      name: group.name,
      children
    };
  }

  _buildPermData(group: PermGroup, perm: SitePerm): any {
    return {
      id: `perm-${perm.id}`,
      name: perm.name,
      parent: group,
      perm: perm
    };
  }

  async deleteGroup(group: PermGroup) {
    if (group.id) {
      await siteAdminPermApis.deletePermGroup(this.siteId, group.id);
    }
    const idx = this.perms.groups.indexOf(group);
    if (idx >= 0) {
      this.perms.groups.splice(idx, 1);
      this.data.splice(idx, 1);
    }
    this.$toast.success(`删除分组[${group.name}]成功`);
  }

  async deletePerm(groupId: number | null, perm: SitePerm) {
    await this.$dialog.confirm({ message: `确定删除角色${perm.title}吗?` }).then(() => {
      siteAdminPermApis.deletePerm(this.siteId, perm.id);
      const groupIdx = this.perms.groups.findIndex(g => g.id === groupId);
      if (groupIdx >= 0) {
        const idx = this.perms.groups[groupIdx].perms.findIndex(p => p.id === perm.id);
        if (idx >= 0) {
          this.perms.groups[groupIdx].perms.splice(idx, 1);
          this.data[groupIdx].children.splice(idx, 1);
        }
      }
      this.$toast.success(`权限[${perm.title}]删除成功`);
    });
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }

  showPermEditDialog(perm: SitePerm | null, group_id?: number) {
    if (perm) {
      this.selectPerm = perm;
    } else {
      this.selectPerm = { site_id: this.siteId, group_id: group_id } as SitePerm;
    }
    this.PermDialogShow = true;
  }

  async save() {
    try {
      if (this.selectPerm) {
        await siteAdminPermApis.savePerm(this.siteId, this.selectPerm);
        this.$toast.success(`保存权限[${this.selectPerm.title}]成功`);
        await this.refreshPerms();
      }
      this.PermDialogShow = false;
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$toast.fail(e.message);
      }
    }
  }

  async showMembersDialog(perm: SitePerm, type: string) {
    this.permType = type;
    this.selectPerm = perm;
    this.membersDialogShow = true;
    await this.getPermMembers();
  }

  async getPermMembers() {
    this.dialogLoading = true;
    this.dialogFinished = false;
    this.members = [];
    await siteAdminPermApis
      .getPermMembers(this.siteId, this.selectPerm.name)
      .then(members => {
        this.members = members;
        this.loading = false;
      })
      .finally(() => {
        this.dialogLoading = false;
        this.dialogFinished = true;
      });
  }

  async updatePermMember(
    writable: boolean,
    add_grant: boolean,
    { employeeId, roleId }: { employeeId?: number; roleId?: number }
  ) {
    await siteAdminPermApis
      .addGrant(this.siteId, this.selectPerm.id, writable, add_grant, { employeeId, roleId })
      .then(() => {
        this.$toast.success(`保存数据成功`);
        this.getPermMembers();
      });
  }
}
